var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.actionComponents),function(ref){
var actionId = ref.actionId;
var action = ref.action;
var component = ref.component;
return _c('v-list-item',{key:actionId},[_c(component,{tag:"component",attrs:{"action":action,"actionParameters":_vm.actionParameters}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }